<template>
    <div class="content-box">
        <!--    上方盒子-->
        <div class="father-box" ref="topBox">
            <el-card class="top-card" style="height: 100%">
                <div class="car-box">
                    <span>车辆信息</span>
                    <el-tooltip class="item" effect="dark" content="最大化" placement="bottom">
                        <i @click="screen(1)" class="el-icon-full-screen"></i>
                    </el-tooltip>
                </div>
                <div class="padding-box" style="height: 95%">
                    <el-table
                            class="tableListValue"
                            v-loading="tableLoadingType"
                            ref="tableRef"
                            :height="!isScreen?tableHeight:'95%'"
                            :data="tableData"
                            stripe
                            style="width: 100%">
                        <el-table-column label="序号" type="index" width="60" align="center">
                            <template #default="scope">
                                <span v-text="getIndex(scope.$index)"></span>
                            </template>
                        </el-table-column>
                        <el-table-column
                                align="center"
                                prop="vin"
                                label="VIN">
                        </el-table-column>
                        <el-table-column
                                align="center"
                                prop="imei"
                                label="终端编号">
                        </el-table-column>
                        <el-table-column
                                align="center"
                                label="终端工作状态">
                            <template slot-scope="scope">
                                {{ onlineStatusObj[scope.row.onlineStatus] }}
                            </template>
                        </el-table-column>
                        <el-table-column
                                align="center"
                                prop="powerOnTime"
                                label="最近一次终端上电时间">
                            <template slot-scope="scope">
                                {{ scope.row.powerOnTime || '-' }}
                            </template>
                        </el-table-column>
                        <el-table-column
                                align="center"
                                label="操作">
                            <template slot-scope="scope">
                                <el-link @click="lookTrajectory(scope.row)" :underline="false" type="primary"
                                         style="font-weight: 700">
                                    查看轨迹
                                </el-link>
                            </template>
                        </el-table-column>
                    </el-table>
                    <div class="pagination">
                        <el-pagination
                                @size-change="handleSizeChange"
                                @current-change="handleCurrentChange"
                                :current-page="currentPage"
                                :page-sizes="[10, 20, 30, 40]"
                                :page-size="pageSize"
                                layout="total, sizes, prev, pager, next, jumper"
                                :total="total">
                        </el-pagination>
                    </div>
                </div>
            </el-card>
        </div>
        <!--    下方盒子-->
        <el-row class="row-box" :gutter="20">
            <el-col :span="18" class="col-box">
                <div class="padding-bottom-box" ref="diagnosisRef">
                    <el-card class="bottom-card">
                        <div class="padding-box" ref="paddingBox2">
                            <div class="journal-box">
                                <span>远程诊断</span>
                                <el-tooltip class="item" effect="dark" content="最大化" placement="bottom">
                                    <i @click="screen(2)" class="el-icon-full-screen"></i>
                                </el-tooltip>
                            </div>
                            <el-row style="height: 100% !important;display: flex">
                                <div :class="isScreen?'isScreen':'noScreen'" style="height: 100% !important;">
                                    <div class="config_box"
                                         :style="[{height:(!isScreen?`${configHeight}px`:'100%')},{overflow:'auto'}]">
                                        <el-form ref="formData" :rules="formRules" :model="formData" label-width="104px"
                                                 label-position="left">
                                            <el-form-item label="VIN" prop="vin">
                                                <el-select style="width: 100%" size="mini" v-model="formData.vin"
                                                           placeholder="请选择VIN" @change="changeVin"
                                                           :popper-append-to-body='false' popper-class='select-popper'>
                                                    <el-option
                                                            v-for="item in vinArr"
                                                            :key="item.vin"
                                                            :label="item.vin"
                                                            :value="item.vin">
                                                    </el-option>
                                                </el-select>
                                            </el-form-item>
                                            <el-form-item label="通道" prop="canChannel">
                                                <el-select style="width: 100%" size="mini"
                                                           v-model="formData.canChannel"
                                                           placeholder="请选择通道"
                                                           :popper-append-to-body='false' popper-class='select-popper'>
                                                    <el-option
                                                            v-for="(item,index) in 2"
                                                            :key="index"
                                                            :label="`通道${index}`"
                                                            :value="index">
                                                    </el-option>
                                                </el-select>
                                            </el-form-item>
                                            <el-form-item label="地址类型" prop="addressType">
                                                <el-select style="width: 100%" size="mini"
                                                           v-model="formData.addressType" placeholder="请选择地址类型"
                                                           :popper-append-to-body='false' popper-class='select-popper'>
                                                    <el-option label="物理地址" value="0"></el-option>
                                                    <el-option label="功能地址" value="1"></el-option>
                                                </el-select>
                                            </el-form-item>
                                            <el-form-item v-if="isCustom" label="指令" prop="instrustDesc">
                                                <div style="display: flex;justify-content: space-between;align-items: center;width: 100%">
                                                    <el-select style="margin-right: 10px;width: 100%" size="mini"
                                                               v-model="formData.instrustDesc" placeholder="请选择指令"
                                                               @change="chanheInstr" :popper-append-to-body='false'
                                                               filterable
                                                               popper-class='select-popper'>
                                                        <el-option
                                                                v-for="item in instructList"
                                                                :key="item.id"
                                                                :label="item.instrustName"
                                                                :value="item.instrustName">
                                                        </el-option>
                                                    </el-select>
                                                    <el-button size="mini"
                                                               style="width: calc(34% - 10px);padding: 7px 6px"
                                                               @click="changeisCustom">自定义
                                                    </el-button>
                                                </div>
                                            </el-form-item>
                                            <el-form-item v-else label="指令" prop="instructions">
                                                <div style="display: flex;justify-content: space-between;align-items: center">
                                                    <el-input placeholder="请输入指令"
                                                              style="width: 100%;margin-right: 10px"
                                                              v-model="formData.instructions" size="mini"></el-input>
                                                    <el-button size="mini" style="width: calc(34% - 10px)"
                                                               @click="changeisCustom">选择
                                                    </el-button>
                                                </div>
                                            </el-form-item>
                                            <el-form-item style="width: 100%" label="请求地址(0X)" prop="sendAddress">
                                                <el-input v-model="formData.sendAddress" size="mini"></el-input>
                                            </el-form-item>
                                            <el-form-item v-if="formData.addressType === '0'" style="width: 100%"
                                                          label="响应地址(0X)" prop="receiveAddress">
                                                <el-input v-model="formData.receiveAddress" size="mini"></el-input>
                                            </el-form-item>
                                            <el-form-item v-if="formData.addressType === '1'" style="width: 100%"
                                                          label="响应地址(0X)">
                                                <el-input v-model="formData.receiveAddress" size="mini"></el-input>
                                            </el-form-item>
                                            <el-form-item label="帧类型" prop="frameType">
                                                <el-select style="width: 100%" size="mini" v-model="formData.frameType"
                                                           placeholder="请选择帧类型" :popper-append-to-body='false'
                                                           popper-class='select-popper'>
                                                    <el-option label="标准帧" value="0"></el-option>
                                                    <el-option label="扩展帧" value="1"></el-option>
                                                </el-select>
                                            </el-form-item>
                                            <el-form-item label="数据长度">
                                                <el-select style="width: 100%" size="mini" v-model="formData.length"
                                                           placeholder="请选择长度" :popper-append-to-body='false'
                                                           popper-class='select-popper'>
                                                    <el-option
                                                            v-for="item in options"
                                                            :key="item.id"
                                                            :label="item.dictName"
                                                            :value="item.dictValue">
                                                    </el-option>
                                                </el-select>
                                            </el-form-item>
                                            <el-form-item>
                                                <div style="display: flex">
                                                    <el-button type="primary" size="mini" @click="addList('formData')">
                                                        添加到列表
                                                    </el-button>
                                                    <el-button size="mini" @click="send('formData')">指令发送</el-button>
                                                </div>

                                            </el-form-item>
                                        </el-form>
                                    </div>
                                </div>
                                <div :class="isScreen?'isScreen2':'noScreen2'" style="height: 100% !important;">
                                    <div class="tableContent_box" v-loading="tableLoading">
                                        <div style="height: 48% !important;">
                                            <span class="content-title-top">发送任务列表</span>
                                            <!--                                            <el-button type="primary" size="mini" @click="moveUp">上移</el-button>-->
                                            <!--                                            <el-button type="primary" size="mini" @click="moveDown">下移</el-button>-->
                                            <el-button type="primary" size="mini" @click="deleteItem">删除</el-button>
                                            <el-button type="primary" size="mini" @click="listSend">列表发送</el-button>
                                            <el-button type="primary" size="mini">停止</el-button>
                                            <el-table
                                                    ref="multipleTable"
                                                    :data="formDataArr"
                                                    class="tableListValue"
                                                    :height="tableContentHeight"
                                                    tooltip-effect="dark"
                                                    :style="[{height:(!isScreen?`${tableContentHeight}px`:'94%')},{width:'100%'}]"
                                                    @selection-change="handleSelectionChange">
                                                <el-table-column
                                                        type="selection"
                                                        width="55">
                                                </el-table-column>
                                                <el-table-column
                                                        align="center"
                                                        label="序号"
                                                        min-width="50">
                                                    <template #default="scope">
                                                        <span v-text="getIndex(scope.$index)"></span>
                                                    </template>
                                                </el-table-column>
                                                <el-table-column
                                                        align="center"
                                                        show-overflow-tooltip
                                                        prop="sendAddress"
                                                        label="请求地址"
                                                        min-width="80">
                                                </el-table-column>
                                                <el-table-column
                                                        min-width="120"
                                                        align="center"
                                                        prop="instructContent"
                                                        label="数据"
                                                        show-overflow-tooltip>
                                                    <template slot-scope="scope">
                                                        {{
                                                        scope.row.instructContent.replace(/\s*/g,"").replace(/(.{2})/g,
                                                        "$1 ") }}
                                                    </template>
                                                </el-table-column>
                                                <el-table-column
                                                        align="center"
                                                        prop="length"
                                                        label="长度"
                                                        min-width="80"
                                                        show-overflow-tooltip>
                                                </el-table-column>
                                                <el-table-column
                                                        align="center"
                                                        prop="frameType"
                                                        label="帧ID类型"
                                                        show-overflow-tooltip>
                                                    <template slot-scope="scope">
                                                        {{ scope.row.frameType === '0'?'标准帧':'扩展帧' }}
                                                    </template>
                                                </el-table-column>

                                                <el-table-column align="center" fixed="right" label="操作" width="84">
                                                    <template slot-scope="scope">
                                                        <el-button
                                                                type="text"
                                                                size="small"
                                                                @click="moveUp(scope.row, scope.$index)"
                                                                :disabled="scope.$index === 0"
                                                        >上移
                                                        </el-button>
                                                        <!-- 这里分别展示了判断是否上移下移的两种方案 -->
                                                        <el-button
                                                                type="text"
                                                                size="small"
                                                                @click="moveDown(scope.row, scope.$index)"
                                                                :disabled="getFormLength(scope.$index)"
                                                        >下移
                                                        </el-button>
                                                    </template>
                                                </el-table-column>
                                            </el-table>
                                        </div>
                                        <div style="height: 40% !important;">
                                            <div class="content-title-bottom"
                                                 style="width:100%;height:15px;margin-top: -15px;display: flex;justify-content: space-between;align-items: center">
                                                <span>诊断数据流</span>
                                                <el-button style="margin-right: 20px" type="text" slot="reference"
                                                           @click="del">清空
                                                </el-button>
                                                <el-dialog
                                                        style="text-align: left"
                                                        :modal-append-to-body="false"
                                                        title="提示"
                                                        :visible.sync="dialogVisible"
                                                        width="30%"
                                                        :before-close="handleClose">
                                                    <span>确定要清空诊断数据流吗？</span>
                                                    <span slot="footer" class="dialog-footer">
                                                        <el-button @click="dialogVisible = false">取 消</el-button>
                                                        <el-button type="primary" @click="clearInstr">确 定</el-button>
                                                    </span>
                                                </el-dialog>
                                                <!--                                                </el-popconfirm>-->
                                            </div>
                                            <div class="instrBox"
                                                 :style="[{height:(!isScreen?`${tableContentHeight}px`:'100%')},{width:'100%'}]"
                                                 style="background: #fafafa;margin-top: 24px;">
                                                <div v-for="item in instr"
                                                     style="display: flex;flex-direction: column;margin-bottom: 6px">
                                                    <div>
                                                        <span v-if="instr"
                                                              style="text-align: left;display: inline-block;width: 130px">请求数据,Len:{{item.len}},</span>
                                                        <span v-if="instr" style="text-align: left">PDU:{{ item.instructContent.replace(/\s*/g,"").replace(/(.{2})/g, "$1 ")  }}</span>
                                                    </div>
                                                    <div>
                                                        <span style="text-align: left;display: inline-block;width: 130px">接收数据,Len:{{item.objData.length}},</span>
                                                        <span style="text-align: left">PDU:{{ item.objData.pdu }}</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </el-row>
                        </div>
                    </el-card>
                </div>
            </el-col>
            <el-col :span="6" class="col-box">
                <div class="padding-bottom-box" ref="scrollbarRef">
                    <el-card class="bottom-card">
                        <div class="padding-box" ref="paddingBox3" style="height: 100%">
                            <div class="journal-box">
                                <span>操作日志</span>
                                <el-tooltip class="item" effect="dark" content="最大化" placement="bottom">
                                    <i @click="screen(3)" class="el-icon-full-screen"></i>
                                </el-tooltip>
                            </div>
                            <el-scrollbar :style="`height: 100%`" wrap-style="overflow-x:hidden;">
                                <el-timeline style="padding-left: 34%">
                                    <el-timeline-item
                                            v-for="(activity, index) in activities"
                                            :key="index"
                                            :timestamp="activity.operateTime">
                                        {{ activity.operateLog }}
                                    </el-timeline-item>
                                </el-timeline>
                            </el-scrollbar>
                        </div>
                    </el-card>
                </div>
            </el-col>
        </el-row>
    </div>
</template>

<script>
    import {getVehicleList, getVinList, downDiagnose} from "../../common/dataReportingApi";
    import {getOperatelogList} from "../../common/journal";
    import ScreenFull from 'screenfull/dist/screenfull'
    import {getDataInstructList, getDictList} from "../../common/command";
    // import {v4 as uuidv4} from 'uuid';

    export default {
        name: "dataReporting",
        data() {
            return {
                dialogVisible: false,
                isScreen: false,
                tableLoading: false,
                isCustom: true,
                options: [],
                vinArr: [],
                // vinArr: [{
                //     vehicleType: "beiqishiyancheceshi11670232755785",
                //     vehicleTypeName: "北汽实验车测试1",
                //     vin: "LRGAM1RT4NA000012",
                // }],
                msg: [],
                msg2: '',
                instructList: [],
                onlineStatusObj: {
                    0: '离线',
                    1: '在线',
                },
                currentPage: 1,
                pageSize: 10,
                total: 0,
                tableLoadingType: false,
                formData: {
                    addressType: "0",
                    sendAddress: '',
                    vin: '',
                    canChannel: '',
                    instrustDesc: '',
                    instrustDesc2: '',
                    instructions: '',
                    frameType: '',
                    length: '',
                    receiveAddress: ''
                },
                formDataArr: [],
                formRules: {
                    vin: [
                        {required: true, message: '请输入VIN', trigger: 'change'},
                    ],
                    canChannel: [
                        {required: true, message: '请选择通道', trigger: 'change'}
                    ],
                    addressType: [
                        {required: true, message: '请选择地址类型', trigger: 'change'}
                    ],
                    sendAddress: [
                        {required: true, message: '请输入请求地址', trigger: 'blur'},
                    ],
                    receiveAddress: [
                        {required: true, message: '请输入响应地址', trigger: 'blur'},
                    ],
                    instrustDesc: [
                        {required: true, message: '请选择指令', trigger: 'change'}
                    ],
                    instructions: [
                        {required: true, message: '请输入指令', trigger: 'blur'}
                    ],
                    frameType: [
                        {required: true, message: '请选择帧类型', trigger: 'change'}
                    ],
                    length: [
                        {required: true, message: '请输入数据长度', trigger: 'blur'},
                    ],
                    num: [
                        {required: true, message: '请输入发送次数', trigger: 'blur'},
                    ]
                },
                activities: [],
                instr: [],
                tableHeight: 0,
                configHeight: 0,
                tableContentHeight: 0,
                tableContentDataHeight: 0,
                scrollbarHeight: 0,
                tableData: [],
                vin: '',
                path: "",
                websock: null,
                uuid: '',
                interval: null
            }
        },
        created() {
            let that = this
            window.onresize = function () {
                if (!that.checkFull()) {
                    // 退出全屏后要执行的动作
                    // that.configHeight = 252
                    that.isScreen = false
                }
            }
        },
        mounted() {
            // websocket(uuidv4()).then(res=>{
            //     console.log(res)
            // }).catch(err=>{
            //     console.log(err)
            // })
            // console.log(uuidv4())
            // var ws = new WebSocket(`ws://172.16.20.162:7080/websocket/${uuidv4()}`);
            // console.log(ws)
            this.formDataArr = JSON.parse(sessionStorage.getItem("formDataArr")) || []
            console.log(this.formDataArr)
            this.$nextTick(function () {
                this.tableHeight = this.$refs.topBox.offsetHeight - 100
                this.scrollbarHeight = this.$refs.scrollbarRef.offsetHeight - 80
                this.configHeight = this.$refs.diagnosisRef.offsetHeight - 80
                this.tableContentHeight = this.$refs.diagnosisRef.offsetHeight / 2 - 60
                this.tableContentDataHeight = this.$refs.diagnosisRef.offsetHeight / 2 - 60
            })
            this.getVehicleList()
            this.getOperatelogList()
            this.getDataInstructList()
            this.initLength()
            this.getVinList()
            this.interval = setInterval(() => {
                this.getOperatelogList()
            }, 5000)
        },
        destroyed() {
            clearInterval(this.interval)
        },
        methods: {
            del() {
                console.log('ssss')
                this.dialogVisible = true
                // this.instr = []
            },
            clearInstr() {
                this.instr = []
                this.dialogVisible = false
            },
            handleClose() {
                this.dialogVisible = false
            },
            // initWebSocket() {
            //
            //     //建立websocket连接
            //     if ("WebSocket" in window) {
            //         //连接服务端访问的url，我这里配置在了env中，就是上面在线测试工具中的地址,下面放了实例
            //         this.uuid = uuidv4()
            //         let ws = `ws://172.16.20.162:7080/bool/websocket/${this.uuid}`;
            //         // let ws = `ws://172.16.20.162:7080/bool/websocket/1111`;
            //         this.websock = new WebSocket(ws);
            //         this.websock.onopen = this.websocketOnopen;
            //         this.websock.onerror = this.websocketOnerror;
            //         this.websock.onmessage = this.websocketOnmessage;
            //         // this.websock.onclose = this.websocketClose;
            //     }
            // },
            // websocketOnopen() {
            //     console.log("连接成功",)
            //     //可以通过send方法来向服务端推送消息，推送的消息在onMessage中可以打印出来查看并做一些业务处理。
            //     this.websock.send("向服务端推送的消息内容",JSON.stringify({uuid:this.uuid}))
            //     console.log('发送成功')
            // },
            // websocketOnerror(e) {
            //     console.log(e,"连接失败",)
            // },
            // websocketOnmessage(e) {
            //     console.log("服务端消息的内容",e.data)
            //     // if (e) {
            //     //     JSON.parse(e.data);//这个是收到后端主动推送的json字符串转化为对象（必须保证服务端传递的是json字符串，否则会报错）
            //     //     //你的业务处理...
            //     //
            //     // }
            //
            // },
            // websocketSend() {
            //     this.websock.send('你好')
            //     console.log('发送成功')
            // },
            // websocketClose(e) {
            //     console.log(e,"连接关闭",)
            // },
            chanheInstr(e) {
                console.log(e)
                let arr = this.instructList.filter(v => {
                    return v.instrustName == e
                })
                console.log(this.instructList)
                // console.log(arr)
                this.formData.sendAddress = arr[0].frameId
                this.formData.addressType = arr[0].addressType
                this.formData.receiveAddress = arr[0].receiveAddress
                this.formData.canChannel = arr[0].canChannel * 1
                this.formData.frameType = arr[0].frameType.toString()
                this.formData.length = arr[0].instructLength
                this.formData.instructContent = arr[0].instructContent.replace(/\s*/g, "");
                this.formData.vehicleType = arr[0].vehicleType
                this.formData.vehicleTypeName = arr[0].vehicleTypeName
                console.log(this.formData)
                // console.log(this.formData.instructContent.replace(/\s*/g,""))
            },
            getFormLength(index) {
                return index === this.formDataArr.length - 1;
            },

            // 上移
            moveUp(item, index) {
                this.tableLoading = true
                setTimeout(() => {
                    this.formDataArr.splice(index - 1, 0, item);  // 定位到点击位置的上一行，0即不删除如何元素，在此位置插入item
                    this.formDataArr.splice(index + 1, 1); // 此时数组中有重复元素，把原来被挤下去的元素删除
                    // console.log(this.formDataArr)
                    sessionStorage.setItem('formDataArr', JSON.stringify(this.formDataArr))
                    // console.log(this.formDataArr)
                    this.$refs.multipleTable.clearSelection();
                    this.tableLoading = false
                }, 1000)
            },
            // 下移
            moveDown(item, index) {
                this.tableLoading = true
                setTimeout(() => {
                    this.formDataArr.splice(index + 2, 0, item);
                    this.formDataArr.splice(index, 1);
                    // console.log(this.formDataArr)
                    sessionStorage.setItem('formDataArr', JSON.stringify(this.formDataArr))
                    this.$refs.multipleTable.clearSelection();
                    this.tableLoading = false

                }, 1000)
            },
            changeVin(e) {
                console.log(e)
                let data = this.vinArr.filter(v => {
                    return v.vin === e
                })
                console.log(data)
                this.formData.vin = data[0].vin
                this.formData.vehicleType = data[0].vehicleType
                this.formData.vehicleTypeName = data[0].vehicleTypeName
                // console.log(this.formData)
                // if (e !== this.vin) {
                //     sessionStorage.removeItem('formDataArr')
                //     this.formDataArr = JSON.parse(sessionStorage.getItem("formDataArr")) || []
                //     // console.log(this.formDataArr)
                // }
            },
            deleteItem() {
                const arr = this.$refs.multipleTable.selection;
                console.log(arr)
                if (arr.length === 0) {
                    this.$notify.error({
                        title: '操作错误 !',
                        message: '请选择数据后操作 !'
                    })
                    return
                }
                this.tableLoading = true
                arr.forEach((v, i) => {
                    this.formDataArr.forEach((k, j) => {
                        // console.log(k.id)
                        if (k.id === v.id) {
                            this.formDataArr.splice(j, 1)
                            sessionStorage.setItem('formDataArr', JSON.stringify(this.formDataArr))
                        }
                    })
                })
                setTimeout(() => {
                    this.tableLoading = false
                }, 1000)

            },
            changeisCustom() {
                this.isCustom = !this.isCustom
                this.formData.instructions = ''
                this.formData.instrustDesc = ''
            },
            addList(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        // alert('submit!');
                        this.tableLoading = true
                        // this.formData.instructContent = this.formData.instructions
                        console.log(this.isCustom)
                        if (!this.isCustom) {
                            this.formData.instructContent = this.formData.instructions
                        } else {
                            this.formData.instructContent = this.formData.instructContent || this.formData.instructions
                        }
                        this.vin = this.formData.vin
                        console.log(this.formData)
                        setTimeout(() => {
                            let item = Object.assign({}, this.formData)
                            item.id = new Date().getTime()
                            this.formDataArr.push(item)
                            sessionStorage.setItem('formDataArr', JSON.stringify(this.formDataArr))
                            this.tableLoading = false
                        }, 1000)
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });
            },
            send(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        this.tableLoading = true
                        // alert('submit!');
                        // console.log('>>>>>>>>>>>>',this.formData.instructions)
                        if (this.formData.instructions) {
                            this.formData.instrustDesc = this.formData.instructions
                        }
                        if (this.formData.instructions) {
                            this.formData.instructContent = this.formData.instructions
                        }
                        // let length = Math.ceil(this.formData.instructContent.length / 2)
                        // // console.log(length)
                        // console.log(this.isCustom)
                        let data = this.formData.instructContent
                        console.log(data)
                        console.log(data.replace(/\s*/g, "").replace(/(.{2})/g, "$1 "))
                        console.log(this.formData)
                        downDiagnose(this.formData).then(res => {
                            // console.log(res.data,res.length)
                            if (res.code === 200) {
                                let length = Math.ceil(this.formData.instructContent.length / 2)
                                // console.log(length)
                                console.log(this.isCustom)
                                let data = this.formData.instructContent
                                // if (!this.isCustom) {
                                //     data = this.formData.instructContent.trim().replace(/(.{2})/g, "$1 ")
                                // } else {
                                //     data = this.formData.instructContent.trim().replace(/(.{2})/g, "$1 ")
                                // }

                                // console.log(data)
                                res.data.forEach(v => {
                                    // console.log(v.data,v.length)
                                    let obj2 = {
                                        pdu: v.data,
                                        length: v.length
                                    }
                                    // console.log(obj)
                                    // this.msg.push(obj2)
                                    let obj = {instructContent: data, len: length, objData: obj2}
                                    this.instr.push(obj)
                                })
                                console.log(this.instr)
                                // this.msg = res.data
                                // console.log(this.msg)
                                // console.log(res.data)
                                // res.data.forEach(v=>{
                                //     // console.log(v.data,v.length)
                                //     let obj = {
                                //         pdu:v.data,
                                //         length:v.length
                                //     }
                                //     // console.log(obj)
                                //     this.msg.push(obj)
                                // })
                                this.$notify.success({
                                    title: '操作成功!',
                                    message: res.msg
                                })
                                this.tableLoading = false
                            } else {
                                this.$notify.error({
                                    title: '操作错误 !',
                                    message: res.msg
                                })
                                this.tableLoading = false
                            }

                        }).catch(err => {
                            console.log(err)
                        })
                        console.log(this.formData)
                    } else {
                        // this.tableLoading = true
                        // this.formData = {
                        //     addressType: 0,
                        //     canChannel: 0,
                        //     frameType: 0,
                        //     instructContent: "19 01 09 01",
                        //     receiveAddress: "72b",
                        //     sendAddress: "723",
                        //     vehicleType: "111",
                        //     vehicleTypeName: "111",
                        //     vin: "12345678911111111",
                        //     sendNums:1
                        // }
                        // downDiagnose(this.formData).then(res=>{
                        //     this.msg = res.data
                        //     this.msg2 = this.formData.instructContent
                        //     this.tableLoading = false
                        // }).catch(err=>{
                        //     console.log(err)
                        // })
                        // console.log('error submit!!');
                        return false;
                    }
                });
            },
            async listSend() {
                const arr = this.$refs.multipleTable.selection;
                console.log(arr)
                if (arr.length === 0) {
                    this.$notify.error({
                        title: '操作错误 !',
                        message: '请选择数据后操作 !'
                    })
                    return
                }
                this.tableLoading = true
                // for循环
                for (let i = 0; i < arr.length; i++) {
                    // let length = Math.ceil(arr[i].instructContent.length / 2)
                    // let data = arr[i].instructContent

                    await downDiagnose(arr[i]).then(res => {
                        if (res.code === 200) {
                            let length = Math.ceil(arr[i].instructContent.length / 2)
                            let data = arr[i].instructContent
                            res.data.forEach(v => {
                                console.log(v.data, v.length)
                                let obj2 = {
                                    pdu: v.data,
                                    length: v.length
                                }
                                let obj = {instructContent: data, len: length, objData: obj2}
                                this.instr.push(obj)
                            })
                            this.$notify.success({
                                title: '操作成功!',
                                message: res.msg
                            })
                            // this.tableLoading = false
                        } else {
                            this.$notify.error({
                                title: '操作错误 !',
                                message: res.msg
                            })
                            // this.tableLoading = false
                        }
                        return
                    }).catch(err => {
                        console.log(err)
                    })
                }
                // console.log('完成')
                this.tableLoading = false
                // eslint-disable-next-line no-unused-vars
                // Promise
                // arr.forEach( (i, index) => {
                //     return new Promise(resolve => {
                //          downDiagnose(i).then(res => {
                //             if (res.code === 200) {
                //                 let length = Math.ceil(i.instructContent.length / 2)
                //                 let data = i.instructContent
                //                 res.data.forEach(v => {
                //                     console.log(v.data, v.length)
                //                     let obj2 = {
                //                         pdu: v.data,
                //                         length: v.length
                //                     }
                //                     let obj = {instructContent: data, len: length, objData: obj2}
                //                     this.instr.push(obj)
                //                 })
                //                 this.$notify.success({
                //                     title: '操作成功!',
                //                     message: res.msg
                //                 })
                //                 resolve(i)
                //                 this.tableLoading = false
                //             } else {
                //                 this.$notify.error({
                //                     title: '操作错误 !',
                //                     message: res.msg
                //                 })
                //                 this.tableLoading = false
                //             }
                //
                //         }).catch(err => {
                //             console.log(err)
                //         })
                //     })
                //
                // })
            },
            async initLength() {
                const res = await getDictList({pageNo: 0, pageSize: 0, dictCode: 'instruct_length'})
                // console.log(res)
                this.options = res.data
            },
            async getVinList() {
                const res = await getVinList({pageNo: 0, pageSize: 0})
                // console.log(res)
                this.vinArr = res.data
                this.vinArr.map(v => {
                    v.id = v.vin
                })
                // console.log(this.vinArr)
            },
            // 获取列表
            async getDataInstructList() {
                this.tableLoadingType = true
                try {
                    const param = {
                        pageNo: this.currentPage,
                        pageSize: this.pageSize,
                    }
                    const res = await getDataInstructList(param)
                    // console.log(res)
                    if (res.code === 200) {
                        this.instructList = res.data
                    } else {
                        this.$notify.error({
                            title: '错误提示',
                            message: res.msg
                        });
                        this.tableLoadingType = false
                    }
                } catch (e) {
                    this.tableLoadingType = false
                    console.log(e)
                }
            },
            checkFull() {
                //判断浏览器是否处于全屏状态 （需要考虑兼容问题）
                //火狐浏览器
                var isFull =
                    document.mozFullScreen ||
                    document.fullScreen ||
                    //谷歌浏览器及Webkit内核浏览器
                    document.webkitIsFullScreen ||
                    document.webkitRequestFullScreen ||
                    document.mozRequestFullScreen ||
                    document.msFullscreenEnabled
                if (isFull === undefined) {
                    isFull = false
                }
                return isFull
            },
            screen(val) {
                if (val === 1) {
                    this.isScreen = true
                    ScreenFull.toggle(this.$refs.topBox); // 全屏切换
                } else if (val === 2) {
                    this.isScreen = true
                    // this.tableContentHeight = 77
                    ScreenFull.toggle(this.$refs.paddingBox2); // 全屏切换
                    // this.configHeight = 500
                } else if (val === 3) {
                    // this.scrollbarHeight = 900
                    ScreenFull.toggle(this.$refs.paddingBox3); // 全屏切换
                }
            },
            getOperatelogList() {
                const data = {
                    pageNo: this.currentPage,
                    pageSize: 20,
                }
                getOperatelogList(data).then(res => {
                    // console.log(res)
                    this.activities = res.data
                }).catch(err => {
                    console.log(err)
                })
            },
            getIndex(index) {
                return (this.currentPage - 1) * this.pageSize + index + 1
            },
            // 查看轨迹
            lookTrajectory(item) {
                sessionStorage.setItem('navIdentification', 18)
                this.$router.push({name: 'trackQuery', params: item})
            },
            // 获取列表
            async getVehicleList() {
                this.tableLoadingType = true
                try {
                    const param = {
                        pageNo: this.currentPage,
                        pageSize: this.pageSize,
                    }
                    const res = await getVehicleList(param)
                    if (res.code === 200) {
                        this.tableData = res.data
                        this.total = res.total
                        this.tableLoadingType = false
                    } else {
                        this.$notify.error({
                            title: '错误提示',
                            message: res.msg
                        });
                        this.tableLoadingType = false
                    }
                } catch (e) {
                    this.tableLoadingType = false
                    console.log(e)
                }
            },
            handleSizeChange(e) {
                this.pageSize = e
                this.getVehicleList()
            },
            handleCurrentChange(e) {
                this.currentPage = e
                this.getVehicleList()
            },
            handleSelectionChange() {
            },
        }
    }
</script>

<style scoped>
    .pagination {
        margin-top: 10px;
        text-align: right;
    }

    .father-box {
        height: 45%;
    }

    .content-title-top {
        position: absolute;
        left: 10px;
        font-size: 14px;
    }

    .content-title-bottom {
        position: absolute;
        left: 10px;
        font-size: 14px;
    }

    .tableContent_box {
        position: relative;
        text-align: right;
        margin-left: 20px;
        border-left: 1px solid #ddd;
        height: 100%;
        padding-left: 20px;
    }

    .config_box {
        padding-right: 20px;
        overflow: auto !important;
    }

    .content-box /deep/ .el-timeline-item__timestamp.is-bottom {
        position: absolute;
        left: -130px;
        top: -4px;
    }

    .el-form-item {
        margin-bottom: 0 !important;
    }

    .journal-box {
        padding: 10px 0 10px 0;
        font-size: 14px;
        display: flex;
        justify-content: space-between;
    }

    .el-icon-full-screen {
        font-weight: bold;
        cursor: pointer;
    }

    .car-box {
        display: flex;
        justify-content: space-between;
        text-align: left;
        padding-left: 20px;
        padding-right: 20px;
        padding-bottom: 10px;
        padding-top: 10px;
        font-size: 14px;
    }

    .padding-box {
        background: #ffffff !important;
        text-align: left;
        padding: 0 20px;
    }

    .padding-bottom-box {
        text-align: left;
        height: 100%;
    }

    .top-card {
        height: 100%;
        border-radius: 10px;
    }

    .bottom-card {
        border-radius: 10px;
        height: calc(100% - 20px);
        margin-top: 20px;
    }

    .content-box /deep/ .el-card__body {
        padding: 0 !important;
    }

    .col-box {
        height: 100%;
    }

    .row-box {
        height: 55%;
    }
</style>
<style scoped lang="scss">
    .tableListValue {
        //滚动条的宽高
        ::-webkit-scrollbar {
            width: 1.5vh;
            height: 1vh;
        }

        //滚动条的滑块背景色
        ::-webkit-scrollbar-thumb {
            background: #ccc;
            border-radius: 1vh;
        }

        //滚动条的背景色
        ::-webkit-scrollbar-track {
            background: rgba(#ccc, 0.3);
        }

    }


    /* 设置滚动条的样式 */
    /*定义滚动条高宽及背景 高宽分别对应横竖滚动条的尺寸*/

    ::-webkit-scrollbar {
        width: 8px;
        height: 8px;
    }


    /*定义滚动条轨道 内阴影+圆角*/

    ::-webkit-scrollbar-track {
        -webkit-box-shadow: inset 0 0 6px rgba(255, 255, 255, 0.1);
        border-radius: 4px;
        background-color: #F5F5F5;
    }


    /*定义滑块 内阴影+圆角*/

    ::-webkit-scrollbar-thumb {
        border-radius: 4px;
        -webkit-box-shadow: inset 0 0 6px rgba(255, 255, 255, 0.1);
        background-color: #ccc;

    }

    ::v-deep .el-form-item__error {
        top: 80%;
    }

    .instrBox {
        font-size: 14px;
        font-family: system-ui;
        /*padding: 8px;*/
        box-sizing: border-box;
        text-align: left;
        display: flex;
        flex-direction: column;
        overflow: hidden;
        overflow-y: scroll;
    }

    ::v-deep .el-card__body {
        height: 100% !important;
    }

    ::v-deep .select-popper {
        /*left: 0 !important;*/
        .el-select-dropdown__item {
            text-align: left;
        }
    }

    ::v-deep .el-table__body-wrapper.is-scrolling-middle {
        height: 77px !important;
    }

    .isScreen {
        width: 25%;
    }

    .isScreen2 {
        width: 75%;
    }

    .noScreen {
        width: 31%;
    }

    .noScreen2 {
        width: 69%;
    }
</style>
